/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPOLICYOWNERSHIP } from './IAPPOLICYOWNERSHIP';
import {
    IAPPOLICYOWNERSHIPFromJSON,
    IAPPOLICYOWNERSHIPFromJSONTyped,
    IAPPOLICYOWNERSHIPToJSON,
} from './IAPPOLICYOWNERSHIP';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { IAPREDUCTIONININCOME } from './IAPREDUCTIONININCOME';
import {
    IAPREDUCTIONININCOMEFromJSON,
    IAPREDUCTIONININCOMEFromJSONTyped,
    IAPREDUCTIONININCOMEToJSON,
} from './IAPREDUCTIONININCOME';
import type { IAPSOURCEOFFUNDS } from './IAPSOURCEOFFUNDS';
import {
    IAPSOURCEOFFUNDSFromJSON,
    IAPSOURCEOFFUNDSFromJSONTyped,
    IAPSOURCEOFFUNDSToJSON,
} from './IAPSOURCEOFFUNDS';

/**
 * 
 * @export
 * @interface ProposalOverviewProductViewModel
 */
export interface ProposalOverviewProductViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    id: number;
    /**
     * 
     * @type {IAPSOURCEOFFUNDS}
     * @memberof ProposalOverviewProductViewModel
     */
    sourceOfFundsId?: IAPSOURCEOFFUNDS;
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof ProposalOverviewProductViewModel
     */
    productConfigurationCode?: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof ProposalOverviewProductViewModel
     */
    productCode?: IAPPRODUCTCODE;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    productCodeId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    productConfigurationId?: number;
    /**
     * 
     * @type {IAPREDUCTIONININCOME}
     * @memberof ProposalOverviewProductViewModel
     */
    reductionInIncomeId?: IAPREDUCTIONININCOME;
    /**
     * 
     * @type {IAPPOLICYOWNERSHIP}
     * @memberof ProposalOverviewProductViewModel
     */
    policyOwnership?: IAPPOLICYOWNERSHIP;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalOverviewProductViewModel
     */
    replacingExistingPolicy?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    lumpSumCommissionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    debitOrderCommissionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewProductViewModel
     */
    annualServiceFeePercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalOverviewProductViewModel
     */
    isInvestmentPaymentDateOveridden?: boolean;
}

/**
 * Check if a given object implements the ProposalOverviewProductViewModel interface.
 */
export function instanceOfProposalOverviewProductViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ProposalOverviewProductViewModelFromJSON(json: any): ProposalOverviewProductViewModel {
    return ProposalOverviewProductViewModelFromJSONTyped(json, false);
}

export function ProposalOverviewProductViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalOverviewProductViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'sourceOfFundsId': !exists(json, 'SourceOfFundsId') ? undefined : IAPSOURCEOFFUNDSFromJSON(json['SourceOfFundsId']),
        'productConfigurationCode': !exists(json, 'ProductConfigurationCode') ? undefined : IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'productCodeId': !exists(json, 'ProductCodeId') ? undefined : json['ProductCodeId'],
        'productConfigurationId': !exists(json, 'ProductConfigurationId') ? undefined : json['ProductConfigurationId'],
        'reductionInIncomeId': !exists(json, 'ReductionInIncomeId') ? undefined : IAPREDUCTIONININCOMEFromJSON(json['ReductionInIncomeId']),
        'policyOwnership': !exists(json, 'PolicyOwnership') ? undefined : IAPPOLICYOWNERSHIPFromJSON(json['PolicyOwnership']),
        'replacingExistingPolicy': !exists(json, 'ReplacingExistingPolicy') ? undefined : json['ReplacingExistingPolicy'],
        'lumpSumCommissionPercentage': !exists(json, 'LumpSumCommissionPercentage') ? undefined : json['LumpSumCommissionPercentage'],
        'debitOrderCommissionPercentage': !exists(json, 'DebitOrderCommissionPercentage') ? undefined : json['DebitOrderCommissionPercentage'],
        'annualServiceFeePercentage': !exists(json, 'AnnualServiceFeePercentage') ? undefined : json['AnnualServiceFeePercentage'],
        'isInvestmentPaymentDateOveridden': !exists(json, 'IsInvestmentPaymentDateOveridden') ? undefined : json['IsInvestmentPaymentDateOveridden'],
    };
}

export function ProposalOverviewProductViewModelToJSON(value?: ProposalOverviewProductViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'SourceOfFundsId': IAPSOURCEOFFUNDSToJSON(value.sourceOfFundsId),
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'ProductCodeId': value.productCodeId,
        'ProductConfigurationId': value.productConfigurationId,
        'ReductionInIncomeId': IAPREDUCTIONININCOMEToJSON(value.reductionInIncomeId),
        'PolicyOwnership': IAPPOLICYOWNERSHIPToJSON(value.policyOwnership),
        'ReplacingExistingPolicy': value.replacingExistingPolicy,
        'LumpSumCommissionPercentage': value.lumpSumCommissionPercentage,
        'DebitOrderCommissionPercentage': value.debitOrderCommissionPercentage,
        'AnnualServiceFeePercentage': value.annualServiceFeePercentage,
        'IsInvestmentPaymentDateOveridden': value.isInvestmentPaymentDateOveridden,
    };
}

